import type { TraderProfile as MesaTraderProfile } from '@/types/api/legacy-trader-profile'

import React from 'react'

import { ButtonVariant } from '@/components/atomic/button'
import { ButtonSize } from '@/components/atomic/button/variants'
import Icon, { PhosphorIconName } from '@/components/atomic/icon'
import ButtonRequiringTraderProfile from '@/trading/trade-desk-blotter/button-requiring-trader-profile'

interface AskActionColumnProps {
  isDisabled: boolean
  borderStatus: boolean
  isHighlight: boolean
  rowHeight: number
  onLiftAsk: (traderProfile: MesaTraderProfile) => void
  isButtonDisabled: boolean
  isLoading: boolean
  showActionButtonsOnAllRows: boolean
  isFirstValidAsk: boolean
  // biome-ignore lint/suspicious/noExplicitAny: Bulk suppression as part of biome migration
  CellComponent: React.ComponentType<any>
}

const AskActionColumn = React.memo<AskActionColumnProps>(
  ({
    isDisabled,
    borderStatus,
    isHighlight,
    rowHeight,
    onLiftAsk,
    isButtonDisabled,
    isLoading,
    showActionButtonsOnAllRows,
    isFirstValidAsk,
    CellComponent,
  }) => (
    <CellComponent
      hasBorder={(!isHighlight || isDisabled) && borderStatus}
      className="p-0"
      height={rowHeight}
    >
      {isDisabled ? (
        <div className="flex items-center justify-end h-8 w-[36px] m-auto mr-2">
          <Icon
            iconName={PhosphorIconName.ProhibitIcon}
            size="medium"
            isPhosphor
          />
        </div>
      ) : (
        <ButtonRequiringTraderProfile
          variant={ButtonVariant.Primary}
          size={ButtonSize.Small}
          label="Lift"
          onClick={onLiftAsk}
          disabled={isButtonDisabled}
          isLoading={isLoading}
          className={`${
            showActionButtonsOnAllRows || isFirstValidAsk ? '' : 'hidden'
          } transition-opacity m-auto mr-1`}
        />
      )}
    </CellComponent>
  ),
)
AskActionColumn.displayName = 'AskActionColumn'

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default AskActionColumn
